import React, { useMemo } from "react";
import Skeleton from "../../../../components/skeleton";

/**
 * Skeleton loader for the clinical case screen.
 * @returns {JSX.Element} The clinical case skeleton component.
 */
const ClinicalCaseSkeleton: React.FC = () => {
  return useMemo(
    () => (
      <div className="flex h-full">
        <div className="flex-1 flex flex-col">
          <div className="flex-1 overflow-y-auto p-4 sm:p-6">
            <div className="h-full flex flex-col items-center justify-center text-center px-4">
              <div className="w-full max-w-5xl">
                {/* Title skeleton */}
                <Skeleton className="h-8 sm:h-12 rounded-lg mb-4" />
                {/* Description skeleton */}
                <Skeleton className="h-4 sm:h-6 rounded-lg mb-8 sm:mb-12 w-full md:w-[60%] mx-auto" />
                {/* Categories skeleton */}
                <div className="space-y-3">
                  {Array.from({ length: 3 }).map((_, rowIndex) => (
                    <div
                      key={rowIndex}
                      className="flex gap-2 sm:gap-3 justify-center"
                    >
                      {Array.from({ length: 4 }).map((_, colIndex) => (
                        <Skeleton
                          key={colIndex}
                          className="h-9 rounded-lg"
                          style={{ width: `${Math.random() * 100 + 80}px` }}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
    [],
  );
};

export default ClinicalCaseSkeleton;
